import { render } from "./PresumedLost.vue?vue&type=template&id=681cc0fd"
import script from "./PresumedLost.vue?vue&type=script&lang=js"
export * from "./PresumedLost.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__